import { RequestMeetingFront } from './request-meeting-front.model';

export class Student {
  id: number;
  firstName: string;
  middleName: string;
  lastName: string;
  email: string;
  fullName: string;
  homeworkStatus: any;
  userId: number;
  addresses: string;
  phones: string;
  
  constructor(data: any) {
    this.id = data.id;
    this.firstName = data.firstName;
    this.middleName = data.middleName;
    this.lastName = data.lastName;
    this.email = data.email;
    this.fullName = data.fullName;
    this.homeworkStatus = data.homeworkStatus;
    this.userId = data.userId;
    this.addresses = data.addresses;
    this.phones = data.phones;
  }
}